import {
  WSElement,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import React, { useMemo, useState } from "react";
import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import {
  RequirementAdditionalData,
  RequirementContextType
} from "../../../Requirements/types";
import { useUserId } from "../../../../query/hooks/helpers";
import { useHistory } from "react-router-dom";
import { ExtendedRequirementsTable } from "../../../Requirements/components/ExtendedRequirementsTable";
import { ExtendedRequirementPreviewList } from "../../../Requirements/components/ExtendedRequirementPreviewList";
import { ExtendedRequirementItem } from "../../../Requirements/modules/GeneralRequirements/types";

export type RouteClientsRequirementsProps = {
  requirements: ExtendedRequirementItem[];
  isLoading: boolean;
};

export const RouteClientsRequirements: React.FC<
  RouteClientsRequirementsProps
> = ({ requirements, isLoading }) => {
  const history = useHistory();
  const userId = useUserId();

  const allRequirements = requirements;

  const completedLength = useMemo(() => {
    return allRequirements.filter(e => e.status === RequirementStatus.Complete)
      .length;
  }, [allRequirements]);

  const isRequirementsComplete = useMemo(() => {
    return allRequirements.every(e => e.status === RequirementStatus.Complete);
  }, [allRequirements]);

  const [showPreviews, setShowPreviews] = useState(false);

  const getOnViewDetails = (
    requirement: ExtendedRequirementItem,
    dataSource: RequirementAdditionalData
  ) => {
    return "requirementId" in requirement
      ? (requirement: IRequirementResponse) =>
          history.push(
            `/member/payers/${requirement.payerId}/requirement/${requirement.requirementId}`
          )
      : undefined;
  };

  return (
    <WSElement>
      <WSList gap="L">
        <WSSectionToolbar
          title="Requirements"
          pill={
            isLoading
              ? undefined
              : {
                  icon: true,
                  text: `${completedLength} of ${allRequirements.length} completed`,
                  theme: isRequirementsComplete ? "success" : "warning"
                }
          }
          buttons={[
            {
              label: "",
              onClick: () => setShowPreviews(true),
              kind: showPreviews ? "Secondary" : "Link",
              icon: "grid",
              onlyIcon: true,
              size: "S"
            },
            {
              label: "",
              onClick: () => setShowPreviews(false),
              kind: !showPreviews ? "Secondary" : "Link",
              icon: "list",
              onlyIcon: true,
              size: "S"
            }
          ]}
        />
        {showPreviews ? (
          <ExtendedRequirementPreviewList
            requirements={allRequirements}
            payeeId={userId}
            payerId={undefined}
            contextType={RequirementContextType.Payer}
            getOnViewDetails={getOnViewDetails}
          />
        ) : (
          <ExtendedRequirementsTable
            payeeId={userId}
            payerId={undefined}
            requirements={allRequirements}
            contextType={RequirementContextType.Payer}
            showOverrideActions
            hideActions={false}
            getOnViewDetails={getOnViewDetails}
          />
        )}
      </WSList>
    </WSElement>
  );
};
